/**
 * Name: Repeater
 * Description: Gère l'ajout dynamique de lignes dans un champ répéteur ACF-like
 */

import ConditionalLogic from '../ConditionalLogic/ConditionalLogic';

export default class Repeater {
  constructor(button) {
    this.button = button;
    this.destination = document.getElementById(this.button.dataset.repeaterDestination);
    this.template = this.button.dataset.repeaterAcfcloneindex;

    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);

    this.init();
  }

  /**
   * Initialise le repeater
   */
  init() {
    this.currentIndex = this.destination ? this.destination.children.length : 0;

    this.button.addEventListener('click', this.addRow);

    this.destination.querySelectorAll('.js-repeater-remove button').forEach(button => {
      button.addEventListener('click', this.removeRow);
    });

    // ➕ Si aucune ligne présente, on en ajoute une
    if (this.destination.children.length === 0) {
      this.addRow(new Event('init'), { isInitial: true });
    }
  }

  /**
   * Ajoute une ligne au repeater
   */
  addRow(e = null, options = {}) {
    if (e) e.preventDefault();

    const rowIndex = Date.now().toString(16) + Math.floor(Math.random() * 10000).toString(16);
    let html = this.template.replace(/acfcloneindex/g, rowIndex);

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const rawRow = tempDiv.firstElementChild;

    const uniqueId = `repeater-row-${rowIndex}`;

    // ✅ Création du fieldset + legend
    const fieldset = document.createElement('fieldset');
    fieldset.id = uniqueId;
    fieldset.dataset.repeaterRow = uniqueId;
    fieldset.classList.add('c-form__fieldset');
    fieldset.classList.add('u-margin--block-350');
    fieldset.classList.add('o-grid');
    fieldset.classList.add('o-grid--form');
    fieldset.classList.add('u-padding--bottom-350');
    fieldset.classList.add('u-border-bottom');
    fieldset.classList.add('u-border-black-opacity');

    const legend = document.createElement('legend');
    legend.textContent = `Participant ${this.currentIndex + 1}`;
    legend.classList.add('u-h4');
    legend.classList.add('o-grid__item');
    legend.classList.add('o-grid__item--legend');
    fieldset.appendChild(legend);

    // Déplacer les enfants de rawRow dans le fieldset
    while (rawRow.firstChild) {
      fieldset.appendChild(rawRow.firstChild);
    }

    this.destination.appendChild(fieldset);

    // Ajout du bouton de suppression s’il existe et que ce n’est pas la ligne initiale
    const removeBtn = fieldset.querySelector('.js-repeater-remove');
    removeBtn.dataset.repeaterRow = uniqueId;
    removeBtn.addEventListener('click', this.removeRow);

    // Activation de la logique conditionnelle pour les champs de cette ligne
    const conditionalFields = fieldset.querySelectorAll('.js-form-field[data-conditional-logic]');
    conditionalFields.forEach(field => {
      new ConditionalLogic(field);
    });

    this.currentIndex++;
  }

  /**
   * Supprime une ligne du repeater
   */
removeRow(e) {
  e.preventDefault();

  const row = e.target.closest('fieldset');

  if (row) {
    const rowId = row.dataset.repeaterRow; // <-- ajout de cette ligne

    // Supprimer la ligne
    row.remove();
    this.currentIndex--;

    // Supprimer le titre associé
    const heading = this.destination.querySelector(`[data-repeater-heading-for="${rowId}"]`);
    if (heading) heading.remove();
  }
}

  /**
   * Détruit le repeater
   */
  destroy() {
    this.button.removeEventListener('click', this.addRow);
    this.destination.querySelectorAll('.js-repeater-remove').forEach(button => {
      button.removeEventListener('click', this.removeRow);
    });
  }
}
